import { OrcamentoValor } from "./Orcamento";

export default class OrcamentoItem {
    
    constructor(model = null){
        
        this.id = 0;
        this.empresaId = 0;
        this.orcamentoId = 0;
        this.planoContaId = 0;
        this.planoConta;
        this.planoContaItemId = 0;
        this.planoContaItem;
        this.valor = new OrcamentoValor();

        if (!model)
            return;
        
        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.orcamentoId = model.orcamentoId;
        this.planoContaId = model.planoContaId;
        this.planoConta = model.planoConta;
        this.planoContaItemId = model.planoContaItemId;
        this.planoContaItem = model.planoContaItem;
        this.valor = model.valor;
    }
}